import { generateRandomGuiID } from '../../../../utils/commonUtils'

export const riskyChars = ['"', '?', '&']

export const checkLength = (filename: any) => {
    if (filename.length > 35) {
        return 'Ce nom dépasse 35 caractères.'
    }
    return null
}

export const checkIsUnique = (filename: any, protectedNames: any, mediaType: any, originalFilename: any) => {
    const protectedNamesCollection = protectedNames[mediaType]

    if (protectedNamesCollection && filename !== originalFilename) {
        const nameAlreadyExists = protectedNamesCollection.find((protectedName: any) => protectedName === filename)
        return nameAlreadyExists ? 'Ce nom est déjà utilisé.' : null
    }
    return null
}

export const checkIsEmpty = (filename: any) => {
    if (filename.length === 0) {
        return "Un nouveau nom est requis pour renommer l'élément."
    }
    return null
}

export const checkAllowedChars = (filename: any) => {
    const containsAllowedChars = !riskyChars.find((char) => filename.includes(char))
    if (!checkIsEmpty(filename) && !containsAllowedChars) {
        return 'Le nouveau nom contient des caratères non autorisés.'
    }
    return null
}

export const validate = (filename: any, protectedNames: any, _mediaType: any, _originalFilename: any) => {
    const methods = [checkLength, checkIsUnique, checkIsEmpty, checkAllowedChars]

    let errors = []
    let isValid = true
    try {
        const validations = methods.map((method) => {
            const result = method(filename, protectedNames, _mediaType, _originalFilename)
            return result || null
        })
        errors = validations.filter((validation) => validation !== null)
        isValid = errors.length === 0
    } catch (error) {
        console.log(error)
        errors = ['Error']
        isValid = false
    }

    return {
        isValid,
        errors,
    }
}

export const attatchIdsToMedia = (mediaList: any) =>
    mediaList.map((media: any) => {
        if (!media.id) media.id = generateRandomGuiID()
        return media
    })
